import React from 'react';
import PropTypes from 'prop-types';

import './text-input.scss';
import { getClass } from '../../../../utils/component-helpers';

const TextInput = props => {
  const { value, name, placeholder, onChange, errors, maxlength, disabled } = props;

  return (
    <div className="input">
      <input
        type="text"
        className={getClass({ invalid: errors.length })}
        name={name}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        maxlength={maxlength}
        disabled={disabled}
      />
      <div className="error-messages">
        {errors.map(message => (
          <div key={message}>{message}</div>
        ))}
      </div>
    </div>
  );
};

TextInput.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  label: PropTypes.string,
  subLabel: PropTypes.string,
  labelType: PropTypes.oneOf(['horizontal', 'vertical']),
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  errors: PropTypes.arrayOf(PropTypes.string),
  maxlength: PropTypes.number,
  disabled: PropTypes.bool,
};

TextInput.defaultProps = {
  value: '',
  label: '',
  labelType: 'vertical',
  subLabel: '',
  placeholder: '',
  required: false,
  onChange: () => {},
  errors: [],
  maxlength: null,
  disabled: false,
};

export default TextInput;
